import React from 'react';
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Login from './pages/login';
import Home from './pages/home';
import Users from './pages/users';
import Booking from './pages/Booking';
import GlobalIdentity from './pages/Globalidentity';
import SiteContent from './pages/Sitecontent';
import ExhibitorDirectory from './pages/Exhibitordirectory';
import BrandDetails from './pages/Branddetails';
import ErrorPages from './pages/Errorpages';
import Error from './pages/error';




const Routess = () => {
  return (
    
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="/home" element={<Home />} />
        <Route path="/users" element={<Users />} />
        <Route path="/booking" element={<Booking />} />
        <Route path="/nav&footer" element={<GlobalIdentity />} />
        <Route path="/site-content" element={<SiteContent />} />
        <Route path="/exhibitors" element={<ExhibitorDirectory />} />
        <Route path="/brands" element={<BrandDetails />} />
        <Route path="/errors" element={<ErrorPages />} />
        <Route path="/error" element={<Error />} />
      
     
  
     
      

      </Routes>
    </BrowserRouter>
  );
};

export default Routess;